import React from 'react';
import { feature } from 'react-openlayers';
import { Coordinate } from 'ol/coordinate';
import { BLACK, GREEN } from '../../../../rgbColors';

type PullinPointFeatureProps = {
  coords: Coordinate;
  id: string;
  selected?: boolean;
  properties?: [key: string];
  zIndex?: number;
};

const PullinPointFeature = ({ coords, id, selected = false, properties, zIndex }: PullinPointFeatureProps) => {
  return (
    <feature.PointReact
      coordinate={coords}
      circleOptions={{
        radius: selected ? 10 : 8,
        fillOptions: { color: GREEN },
        strokeOptions: { color: BLACK, width: 2 },
      }}
      properties={properties}
      key={id}
      zIndex={zIndex}
    />
  );
};

export default PullinPointFeature;
